import {Autocomplete, TextField, TableContainer, TableHead, TableBody, TableCell, TableRow, Paper, Table, Grid, IconButton, CircularProgress} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import RefreshIcon from '@mui/icons-material/Refresh';
import GpsOffIcon from '@mui/icons-material/GpsOff';
import React, {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import {observer} from 'mobx-react';
import {TAB_MISSING, TAB_CITY_MISSING} from './StatsCommon.js';
import {useGlobalStorage} from '../mobx/GlobalStorage.js';
import {getCityName, getShortSpecName} from '../Trans.js';
import StatsFilter from './StatsFilter.js';
import {COMM_OK} from '../WsR2.js';

const StatsCityMissing = observer((props) => {
	const [userAdjusted, setUserAdjusted] = useState(false);
	const [gpsColor, setGpsColor] = useState('white');
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');
	let pos;

	useEffect(() => {
		gStorage.add.setCityList(gStorage.lists.citylist.list.filter(x => x.country === gStorage.stats.country.id).toSorted(cityNameSortfn));

		const id = setInterval(() => {setGpsColor(gpsFgColor(gStorage.gps))}, 1000);

		return () => {
			clearInterval(id);
		};
		// eslint-disable-next-line
	}, []);
	
	function cityNameSortfn(a, b) {
		return statsCityMissingGetCityName(a).localeCompare(statsCityMissingGetCityName(b), 'fi');
	}

	function statsCityMissingCountryChange(event) {
		const country = gStorage.lists.countrylist.find(c => c.id === event.target.value);

		gStorage.stats.setCountry(country);
		gStorage.add.setCityList(gStorage.lists.citylist.list.filter(x => x.country === country.id).toSorted(cityNameSortfn));

		gStorage.stats.setCity(null);
		gStorage.stats.setObsList(null);

		setUserAdjusted(true);
	}

	function cityChange(event, value) {
		// console.log('cityChange', event, value);

		gStorage.stats.setCity(value);
		gStorage.stats.setObsList(null);

		setUserAdjusted(true);
	}

	function statsCityMissingGetCityName(city) {
		return getCityName(city, gStorage.conn.user);
	}

	function statsCityMissingGetSpecName(spec_id) {
		const spec = gStorage.lists.speclist.list.find((x) => x.id === spec_id);

		return getShortSpecName(spec, gStorage.conn.user);
	}

	function copyToClipboard() {
		let cpText = '';

		gStorage.stats.obsList.forEach((item, i) => {
			if (i < 50) {
				if (cpText.length)
					cpText += ', ';

				cpText += statsCityMissingGetSpecName(item.taxon);
			}
		});

		navigator.clipboard.writeText(cpText);
	}

	function statsCityMissingRxWs(status, msg) {
		if (status !== COMM_OK) {
			alert('statsCityMissingRxWs: error ' + status);
			return;
		} else if (msg.result !== 'OK') {
			alert('statsCityMissingRxWs: ' + msg.data.desc + '!');
			return;
		}

		if (gStorage.stats.tab !== TAB_MISSING || gStorage.stats.missing_tab !== TAB_CITY_MISSING)
			return;

		console.log('statsCityMissingRxWs', msg);
		gStorage.stats.setObsList(msg.data.citymissing);
	}

	function loadCityMissing() {
		const msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'location',
			op: 'citymissing',
			data: {
				country: gStorage.stats.country.id,
				city: gStorage.stats.city.id,
				user: gStorage.conn.user.id,
			}
		};

		// console.log('loadCityMissing', msg);
		gStorage.conn.ws.send(msg, statsCityMissingRxWs);
	}

	function cityMissingCoordRxWs(status, msg) {
		if (status !== COMM_OK) {
			console.error('cityMissingCoordRxWs: error ' + status);
			return;
		} else if (msg.result !== 'OK') {
			console.error('cityMissingCoordRxWs: ' + msg.data.desc + '!');
			return;
		}

		if (gStorage.stats.tab !== TAB_MISSING || gStorage.stats.missing_tab !== TAB_CITY_MISSING)
			return;

		// console.log('cityMissingCoordRxWs', msg);

		if (msg.data.city === 0) {
			console.log('cityMissingCoordRxWs: no city found!');
			return;
		}

		if (msg.data.citymissingcoord.city) {
			const city = gStorage.lists.citylist.list.find((c) => c.id === msg.data.citymissingcoord.city);

			if (!gStorage.stats.city || gStorage.stats.city.id !== msg.data.citymissingcoord.city || !gStorage.stats.country || city.country !== gStorage.stats.country.id) {
				const country = gStorage.lists.countrylist.find(x => x.id === city.country);
				
				if (country.id !== gStorage.stats.country.id) {
					gStorage.stats.setCountry(country);
					gStorage.add.setCityList(gStorage.lists.citylist.list.filter(x => x.country === country.id).toSorted(cityNameSortfn));
				}

				gStorage.stats.setCity(city);
			}

			gStorage.stats.setObsList(msg.data.citymissingcoord.list);
		} else {
			gStorage.stats.setObsList([]);
			gStorage.stats.setCity(null);
		}

		setUserAdjusted(false);
	}

	function loadCityMissingCoord() {
		const msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'location',
			op: 'citymissingcoord',
			data: {
				user: gStorage.conn.user.id,
				lat: Math.floor(gStorage.gps.pos.latitude * 1000000),
				lon: Math.floor(gStorage.gps.pos.longitude * 1000000)
			}
		};

		// console.log('loadCityMissingCoord', msg);
		gStorage.conn.ws.send(msg, cityMissingCoordRxWs);
	}

	const gpsFgColor = (gps) => {
		if (!gps || !gps.pos)
			return 'red';

		if (!gps.pos.accuracy)
			return 'black';

		if (gps.pos.accuracy < 9)
			return 'green'; 

		return 'gold';
	}

	const refreshCity = () => {
		// console.log('refreshCity');
		loadCityMissingCoord();
	}

	if (gStorage.stats.tab !== TAB_MISSING || gStorage.stats.missing_tab !== TAB_CITY_MISSING)
		return null;

	/* If country has changed? */
	if (gStorage.stats.city && gStorage.stats.country && gStorage.stats.city.country !== gStorage.stats.country.id) {
	    gStorage.add.setCityList(gStorage.lists.citylist.list.filter(x => x.country === gStorage.stats.country.id).toSorted(cityNameSortfn));
	    gStorage.stats.setCity(null);
		setUserAdjusted(true);

		return null;
	}

	if (!gStorage.stats.obsList && gStorage.conn.online) {
		if (gStorage.gps.available && !userAdjusted) {
			loadCityMissingCoord();

			return (
				<Grid container direction="column" justifyContent="center" alignItems="center" spacing={0}>
					<CircularProgress sx={{mt: 10}} />
				</Grid>
			);

		} else if (gStorage.stats.city && gStorage.stats.country) {
			loadCityMissing();

			return (
				<Grid container direction="column" justifyContent="center" alignItems="center" spacing={0}>
					<CircularProgress sx={{mt: 10}} />
				</Grid>
			)
		}
	}

	pos = 0;

	return (
		<Grid container direction="row" justifyContent="center" alignItems="center" spacing={0}>
			<Grid size={{xs: 12}} align={'center'}>
				<StatsFilter 
					loc = {{country: {
							onChange: statsCityMissingCountryChange,
							value: gStorage.stats.country,
							style: {width: 200}
						}
					}}
				/>
			</Grid>

			<Grid size={{xs: 12}} align={'center'}>
				<Autocomplete id='ac-city'
					options={gStorage.add.citylist}
					getOptionLabel={option => statsCityMissingGetCityName(option)}
					value={gStorage.stats.city}
					autoSelect
					onChange={cityChange}
					style={{width: 300 - 96, margin: 4}}
					renderInput={params => (
						<TextField {...params} label={t('stats.city')} variant="outlined" size="small" fullWidth />
					)} />
			</Grid>
		
			<Grid size={{xs: 12}} align={'center'}>
				<IconButton 
				    aria-label="accuracy"
				    edge="start" 
				    color="inherit"
				    disabled={true}
				    sx={{ml: 2, mr: 2, mt: 2}}
				>
					{gStorage.gps.available ?
						<GpsFixedIcon 
						    sx={{color: gpsColor}}
						/>
					:
					<GpsOffIcon 
					    sx={{color: 'red'}}
					/>
					}
				</IconButton>

				<IconButton 
				    aria-label="refresh"
				    edge="start" 
				    color="inherit"
				    sx={{ml: 2, mr: 2, mt: 2}}
				    onClick={refreshCity} 
				    disabled={!gStorage.conn.online || !gStorage.gps.available}
				>
					<RefreshIcon />
				</IconButton>
				
				<IconButton 
				    aria-label="copy"
				    edge="start" 
				    color="inherit"
				    sx={{ml: 2, mr: 2, mt: 2}}
				    onClick={copyToClipboard} 
				    disabled={!gStorage.stats.obsList || !gStorage.stats.obsList.length}
				>
					<ContentCopyIcon />
				</IconButton>
			</Grid>

			{gStorage.stats.obsList && gStorage.stats.obsList.length ? 
				<TableContainer component={Paper} elevation={0} style={{width: 300, margin: 2}}>
					<Table size='small'>
						<TableHead>
							<TableRow>
								<TableCell padding='none'>#</TableCell>
								<TableCell>{t('stats._species')}</TableCell>
								<TableCell/>
								<TableCell align='right'>{t('stats.score')}</TableCell>
							</TableRow>
						</TableHead>
						
						<TableBody>
							{gStorage.stats.obsList.map((elem, ind) => {
								if (elem.score <= 1) 
									return null;

								pos += 1;

								return (
									<TableRow key={ind}>
										<TableCell padding='none'>{pos}</TableCell>
										<TableCell colSpan={2}>{statsCityMissingGetSpecName(elem.taxon)}</TableCell>
										<TableCell align='right'>{elem.score}</TableCell>
									</TableRow>
								);
							})}
						</TableBody>
					</Table>
				</TableContainer>
			:
				null
			}
		</Grid>
	);
});

export default StatsCityMissing;
